module.exports = __webpack_public_path__ + "svg/flags/Heard Island and McDonald Islands.svg";